module.exports = ".user-avatar {\n  margin-left: 0px !important;\n  margin-top: 0px !important;\n  width: auto !important;\n  height: 300px ;\n}\n\n.seal {\n  background: url(https://d2zmbkdpl0cf9q.cloudfront.net/../assets/icons/seal.svg) center center no-repeat;\n  width: 165px;\n  height: 165px;\n}\n\n.no-margin {\n  margin: 0px;\n}\n\n@media screen and (max-width: 1540px) {\n  .user-avatar{\n    height: 200px !important;\n  }\n}\n\n.bio-detail {\n  font-size: 16px;\n}\n\n.profileInfoDiv {\n  padding-top: 25px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/profile/profile.component.css
// module id = ./src/app/user/profile/profile.component.css
// module chunks = main